import { RabbitVariantOutlineIcon } from './RabbitVariantOutlineIcon';

/**
 * author: Google
 * id 3A22546F-5A22-4E53-A13D-05FB82BAB08F
 * name rabbit-variant-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rabbit-variant-outline.svg
 * tags
 * - Animal 
 * - Holiday 
 * - Nature 
 */
export const BunnyOutlineIcon = RabbitVariantOutlineIcon;
export default BunnyOutlineIcon